 
import toast, { Toaster } from 'react-hot-toast';
import ConnectButton from './components/ConnectButton';
import { Link } from 'react-router-dom';
 

import { Hardcap, MaximumBuy, MinimumBuy, SaleEndTime, TokenRatePerEth, TotalSolded } from "../../hooks/useReadPresale";
import { useEffect, useState } from 'react';
import { useAccount, useBalance } from 'wagmi';
import { BuyToken } from '../../hooks/useWritePresale';
import Contracts from '../../config/contract.json';
import { useWeb3Modal } from '@web3modal/wagmi/react'
import CountdownCard from './components/CountdownCard';



function Home() {

    const { address,isConnected } = useAccount();
     
   const totalSoldedETH = TotalSolded() / 1e18;
   const hardcap = Hardcap() / 1e18;
   const minBuy = MinimumBuy() / 1e18;
   const maxBuy = MaximumBuy() / 1e18;

    const TPerETH = TokenRatePerEth();

    const c = totalSoldedETH / hardcap;
   // const progressbarvalue = Math.ceil(c * 100);

   const progressbarvalue = 100;


   const [token0,setToken0] = useState(); 
   const [token1,setToken1] = useState();

   const handleBnbChange = (e) =>{
    setToken0(e.target.value)
    const tokenamount = TPerETH * e.target.value;
    setToken1(tokenamount); 
}

const { data } = useBalance({address: address});

const balance = data ? data.formatted : 0;

    const clickButton = () =>{
            if(token0 > 0 && balance > token0){
 
                BuyToken(token0,Contracts.presale).then((e)=>{
            
                    if(e.status == "success"){

                        toast.success("Buy Success");
                    
                    }else if(e.status == "error"){
                         
                        if(e.message.details){
                            toast.error(e.message.details);
                        }else{
                            toast.error(e.message.cause.data.args[0]);
                        }                          
                    }
                });

            }else{
                toast.error("Balance Error");
            }
        
    }


     const { open } = useWeb3Modal();
 
    const ConnectWallet = () =>{
        open();
    }
 
  const endTime = SaleEndTime(); 
  
  const addTokenToMetamask = async () => {

    try{

        const wasAdded = await window.ethereum.request({
            method: 'wallet_watchAsset',
            params: {
              type: 'ERC20',  
              options: {
                address: "0x72044643fCF7782B3d8d1CAdAF2E430aDCB18ea6",  
                symbol: "TRP",  
                decimals: "18", 
                image: "https://trumpcoinmining.net/assets/img/TRUMP.png", 
              },
            },
          });
  
          if (wasAdded) {
            toast.success("Added Token");
            console.log('Added Token!');
          } 

    }catch(e){

        toast.error(e.message);

    }
};
 
  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />
      
      <div className="section-padding-100 relative counter-bg">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 col-lg-10 offset-lg-1 col-md-12 pre-sale-bg wavy-border">
              <div className="row">
                 
                <div className="col-12 col-lg-12 col-md-12 ">

                <div className="announcement-box">
  
                    <div className="announcement-content">
                    📣 The future is mine! Needless to say, both the metaverse and mining are mine! Soon!
                    </div>
                  </div>

                   {/* }

                    <div className="ico-counter">
                      <div className="counter-down">
                        <div className="content">
                          <div className="conuter-header">
                            <h3 className="w-text text-center">TOKEN SALE ENDS IN</h3>
                          </div>

                            <CountdownCard endTime={endTime} />
  
                        </div>
                      </div>

                    


                  </div>
                  {*/ }
                </div> 
                <div className="col-12 col-lg-12 col-md-12 mt-s">
 
                  <img src="img/core-img/payment.png" alt="" />

                  <div className='row'>

                  <div className='col-lg-12'>
 
                    <div className='alert alert-box text-center' style={{wordWrap:"break-word"}}>
                     Presale Contract Address <br/>
                      {Contracts.presale}
                      </div>

                      <div className='text-center mb-3'>1 BNB = {TPerETH} TRP</div>
                  </div>

                    <div className='col-lg-12'>

                        <div className="ico-progress ">
                          
                        <div class="col-lg-12 ">

                        <span   style={{color:"white"}}>Min Buy: {minBuy} BNB</span>
                        <span className="pull-right" style={{color:"white"}}>Max Buy: {maxBuy} BNB</span>
                        
                        <div className="current-progress">
                          <div className="progress-bar has-gradient" style={{width: progressbarvalue+'%'}} />
                        </div>

                          <span className="pull-left" style={{color:"white"}}>Solded: {totalSoldedETH} BNB</span>
                          <span className="pull-right" style={{color:"white"}}>HardCap: {hardcap} BNB</span>
                        </div>
                      </div>
 
                      <br/>
                      <br/>
                      
                      <br/>


                    </div>
                  
                  <div class="col-lg-12">
                      <div class="group ">
                        BNB VALUE
                          <input type="text" name="name" onChange={handleBnbChange} value={token0} id="name" required />
                           
                      </div>
                  </div>

                  <div class="col-lg-12 ">
                      <div class="group">
                        TRUMP
                          <input type="text" name="name" value={token1} id="name" readOnly />
                      </div>
                  </div>

                  <div class="col-lg-12 ">
                      <div class="group">
                      <button className="btn modern-button w-100" onClick={isConnected ? clickButton : ConnectWallet} >{isConnected ? "Buy Token": "Connect Wallet" }</button>
                      </div>
                  </div>


                  <div class="col-lg-12 ">
                      <div class="group">
                      <button className="btn modern-button w-100" onClick={addTokenToMetamask} >Add TRP Metamask</button>
                      </div>
                  </div>


                  <div className='col-lg-12'>
 
                    <div className='alert alert-box text-center' style={{wordWrap:"break-word"}}>
                     TRP Token Contract Address <br/>
                     0x72044643fCF7782B3d8d1CAdAF2E430aDCB18ea6 <br/>
                     (Do not send BNB here)
                      </div>
 
                  </div>


                  
 
                  </div>

                </div>
  
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
  
  
  }
  
  export default Home;